import React, { useState } from 'react';
import { UserAddOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import NewRecordForm from 'modules/dashboard/form/Form';
import { useMediaQuery } from 'react-responsive';

const NewRecord = ({ onSuccess }) => {
  const isSmallScreen = useMediaQuery({ maxWidth: 768 });
  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleAddNewRecordSuccess = () => {
    if (typeof onSuccess === 'function') {
      onSuccess();
    }

    handleCloseModal();
  };

  return (
    <>
      <Button
        type="primary"
        size={isSmallScreen ? 'middle' : 'large'}
        icon={<UserAddOutlined />}
        onClick={showModal}
      >
        Thêm Ứng viên
      </Button>
      <Modal
        open={open}
        title="Thêm Ứng viên"
        onCancel={handleCloseModal}
        footer={null}
        destroyOnClose
        style={{ top: 20 }}
      >
        <NewRecordForm onSuccess={handleAddNewRecordSuccess} />
      </Modal>
    </>
  );
};

export default NewRecord;
